import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCnKj1BVj17U6Si8fruMRYOut7RO3lAFvM",
  authDomain: "infinite-trade-markets.firebaseapp.com",
  projectId: "infinite-trade-markets",
  storageBucket: "infinite-trade-markets.appspot.com",
  messagingSenderId: "407991707551",
  appId: "1:407991707551:web:cb9404f5f36f70f2cbffaa",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
